import React, {useContext,useState} from 'react';

import {MyContext} from '../../login/MyContext';

import Inicio from '../inicio/Inicio';

function Crear_usuarios() {

    const {toggleNav,registerUser} = useContext(MyContext);
    const initialState = {
        userInfo:{
            name:'',
            apellidos:'',
            celular:'',
            tdoc:'',
            documento:'',
            email:'',
            clave:'',
            cargo:''  
        },
        errorMsg:'',
        successMsg:'',
    }

    const [state,setState] = useState(initialState);

     // On Submit the Registration Form
     const submitForm = async (event) => {
        event.preventDefault();
        const data = await registerUser(state.userInfo);
        if(data.success){
            setState({
                ...initialState,
                successMsg:data.message,
            });
        }
        else{
            setState({
                ...state,
                successMsg:'',
                errorMsg:data.message
            });
        }
    }

    // On change the Input Value (name, email, password)
    const onChangeValue = (e) => {
        setState({
            ...state,
            userInfo:{
                ...state.userInfo,
                [e.target.name]:e.target.value
            }
        });
    }

     // Show Message on Success or Error
     let successMsg = '';
     let errorMsg = '';
     if(state.errorMsg){
         errorMsg = <div className="error-msg">{state.errorMsg}</div>;
     }
     if(state.successMsg){
         successMsg = <div className="success-msg">{state.successMsg}</div>;
     }

     const {rootState,logoutUser} = useContext(MyContext);
     const {isAuth,theUser,showLogin} = rootState;
   
     if(isAuth && theUser.rol =="admin")
     {
    return (
<div className="content-wrapper">
    
    <div className="content-header">
      <div className="container-fluid">
        
          <div className="col-sm-12">

          <div class="card card-primary">
              <div class="card-header">
              <h3 class="card-title">CREAR USUARIO</h3>
              </div>
            
              <div class="card-body">
                <form onSubmit={submitForm}>
                  <div class="row">    
                       
                    <div class="col-sm-3">
                    <div class="form-group">
                    <input name="name" required type="text" className="form-control"
                     value={state.userInfo.name} onChange={onChangeValue} placeholder="Nombres"/>
                    </div>                      
                    </div>

                    <div class="col-sm-3">   
                    <div class="form-group">
                    <input type="text" name="apellidos" className="form-control" id="inputSuccess"
                    value={state.userInfo.apellidos} onChange={onChangeValue} placeholder="Apellidos" />
                    </div>
                    </div>

                  <div class="col-sm-2">
                  <div class="form-group">
                    <input type="number" name="celular" className="form-control" id="inputSuccess" 
                    value={state.userInfo.celular} onChange={onChangeValue}  placeholder="Celular" />
                    </div>
                    </div>

                    <div class="col-sm-2">
                    <select name="tdoc" className="form-control" value={state.userInfo.tdoc} onChange={onChangeValue}>
                    <option value='no' selected>T.doc</option>
                    <option value="Cedula">Cedula</option>
                    <option value="DNI">DNI</option>
                    <option value="T. identidad">T. identidad</option>
                    </select>     
                    </div>

                    <div class="col-sm-2">
                    <input type="number" name="documento"  className="form-control" id="inputSuccess" 
                    value={state.userInfo.documento} onChange={onChangeValue} placeholder="Documento" />

                    </div>

                 
                    </div>

                    <div class="row">
                        
                    <div class="col-sm-5">
                    <div class="form-group">
                    <input name="email" className="form-control is-valid" required type="email" 
                    value={state.userInfo.email} onChange={onChangeValue} placeholder="Email" />
                    </div>
                    </div>

                    <div class="col-sm-2">
                    <div class="form-group">
                    <input type="password" name="clave" className="form-control is-valid"  required  
                    value={state.userInfo.clave} onChange={onChangeValue} placeholder="Contraseña" />
                    </div>
                    </div>

                    <div class="col-sm-5">
                    <div class="form-group">
                    <input type="text" name="cargo" className="form-control" required 
                    value={state.userInfo.cargo} onChange={onChangeValue} placeholder="Cargo" />
                    </div>
                    </div>

                    </div>
                  
                    <div class="col-sm-12">

                   <p><b>{errorMsg}{successMsg}</b></p>
                                  
                    </div>
                    
                    <button className="btn btn-primary" type="submit"><i class="fas fa-save"></i> Registrar usuario</button>
                </form>
              </div>
             
            </div>     

      </div>

      </div>
      </div>
    
  </div>
    )
}

else if(showLogin){
    return "";
}
else{
  return <Inicio/>;
}

}

export default Crear_usuarios
